import { render, staticRenderFns } from "./dialog-createrelationinbox.vue?vue&type=template&id=64f5374b&"
import script from "./dialog-createrelationinbox.vue?vue&type=script&lang=js&"
export * from "./dialog-createrelationinbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports